'use strict';Object.defineProperty(exports, "__esModule", { value: true });var _styles = require('@material-ui/core/styles');exports.default =

(0, _styles.createMuiTheme)({
  palette: {
    primary: {
      main: '#47b368',
      contrastText: '#ffffff' },

    secondary: {
      main: '#f18c00',
      contrastText: '#ffffff' },

    background: {
      default: '#273d44' } } });
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy90aGVtZXMvQmFzZVRoZW1lLmpzIl0sIm5hbWVzIjpbInBhbGV0dGUiLCJwcmltYXJ5IiwibWFpbiIsImNvbnRyYXN0VGV4dCIsInNlY29uZGFyeSIsImJhY2tncm91bmQiLCJkZWZhdWx0Il0sIm1hcHBpbmdzIjoiMkVBQUEsa0Q7O0FBRWUsNEJBQWU7QUFDNUJBLFdBQVM7QUFDUEMsYUFBUztBQUNQQyxZQUFNLFNBREM7QUFFUEMsb0JBQWMsU0FGUCxFQURGOztBQUtQQyxlQUFXO0FBQ1RGLFlBQU0sU0FERztBQUVUQyxvQkFBYyxTQUZMLEVBTEo7O0FBU1BFLGdCQUFZO0FBQ1ZDLGVBQVMsU0FEQyxFQVRMLEVBRG1CLEVBQWYsQyIsImZpbGUiOiJCYXNlVGhlbWUuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBjcmVhdGVNdWlUaGVtZSB9IGZyb20gJ0BtYXRlcmlhbC11aS9jb3JlL3N0eWxlcyc7XG5cbmV4cG9ydCBkZWZhdWx0IGNyZWF0ZU11aVRoZW1lKHtcbiAgcGFsZXR0ZToge1xuICAgIHByaW1hcnk6IHtcbiAgICAgIG1haW46ICcjNDdiMzY4JyxcbiAgICAgIGNvbnRyYXN0VGV4dDogJyNmZmZmZmYnLFxuICAgIH0sXG4gICAgc2Vjb25kYXJ5OiB7XG4gICAgICBtYWluOiAnI2YxOGMwMCcsXG4gICAgICBjb250cmFzdFRleHQ6ICcjZmZmZmZmJyxcbiAgICB9LFxuICAgIGJhY2tncm91bmQ6IHtcbiAgICAgIGRlZmF1bHQ6ICcjMjczZDQ0JyxcbiAgICB9LFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ../@react-components/dist/themes/BaseTheme.js
// module id = 163
// module chunks = 0